import { render, staticRenderFns } from "./CommissionsHome.vue?vue&type=template&id=25eb73d0&"
import script from "./CommissionsHome.vue?vue&type=script&lang=js&"
export * from "./CommissionsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports